import NotificationApplicationUsersGridData from "./NotificationApplicationUsersGridData"
import NotificationApplicationUsersSearchParams from "./NotificationApplicationUsersSearchParams"
import NotificationContactData from "./NotificationContactData"
import NotificationContactsDeleteParams from "./NotificationContactsDeleteParams"
import NotificationContactsGetParams from "./NotificationContactsGetParams"
import NotificationEvents from "./NotificationEvent"
import NotificationGridData from "./NotificationGridData"
import NotificationSendParams from "./NotificationSendParams"
import NotificationMethod from "../../Notifications/Model/NotificationMethod"
import { ObservableFromFetch } from "../../ObservableFromFetch"

export function GetNotificationContactsObservable(params: NotificationContactsGetParams) {
  const requestBody: string = JSON.stringify(params)
  return ObservableFromFetch<NotificationGridData>("WorkforceRandomNotification/GetNotificationContacts", requestBody)
}

export function GetNotificationApplicationUsersObservable(params: NotificationApplicationUsersSearchParams) {
  const requestBody: string = JSON.stringify(params)
  return ObservableFromFetch<NotificationApplicationUsersGridData>(
    "WorkforceRandomNotification/SearchNotificationApplicationUsers",
    requestBody
  )
}

export function SaveNotificationContactObservable(params: NotificationContactData) {
  const parsedParams = {
    PoolID: params.PoolID,
    ContactID: params.ContactID,
    ApplicationUserID: params.ApplicationUserID,
    NotificationMode: params.NotificationMode,
    NotificationMethodIDs: params.NotificationMethods.filter((x) => x.selected).map((x) => x.NotificationMethodID),
    NotificationEventsIDs: params.NotificationEvents.filter((x) => x.selected).map((x) => x.RandomNotificationEventID),
  }
  const requestBody: string = JSON.stringify(parsedParams)
  return ObservableFromFetch<string>("WorkforceRandomNotification/SaveNotificationContact", requestBody)
}

export function DeleteNotificationContactsObservable(params: NotificationContactsDeleteParams) {
  const requestBody: string = JSON.stringify(params)
  return ObservableFromFetch<string>("WorkforceRandomNotification/DeleteNotificationContacts", requestBody)
}

export function SendNotificationsObservable(params: NotificationSendParams) {
  const requestBody: string = JSON.stringify(params)
  return ObservableFromFetch<string>("WorkforceRandomNotification/SendNotifications", requestBody)
}

export function GetNotificationMethodsObservable() {
  return ObservableFromFetch<NotificationMethod[]>("WorkforceRandomNotification/GetNotificationDeliveryMethods")
}

export function GetNotificationEventsObservable() {
  return ObservableFromFetch<NotificationEvents[]>("WorkforceRandomNotification/GetNotificationEvents")
}
